import React from 'react';
import styled from 'styled-components';

const SmallValue = styled.div`
  font-weight: 600;
  line-height: 19px;
  font-size: 16px;
  color: ${props => props.color};
`;

export default SmallValue;
